module.exports = __webpack_public_path__ + "img/pe.3bb3364.png";